import { render, staticRenderFns } from "./PromotionIntegrationConfigModal.vue?vue&type=template&id=684037d9&scoped=true"
import script from "./PromotionIntegrationConfigModal.vue?vue&type=script&lang=js"
export * from "./PromotionIntegrationConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684037d9",
  null
  
)

export default component.exports